export const TYPE = {
    ADDRESS: 1,
    ON_SITE_REPAIR: 2,
};